module.exports = __webpack_public_path__ + "static/media/next_arr.06353a77.png";